import {ChangeEvent, FC} from 'react';
import {Input} from '~library/atoms/Input';

interface PhoneProps {
  value: string;
  onChange: (value: string) => void;
  error?: string | boolean;
}

export const Phone: FC<PhoneProps> = ({value, onChange, error}) => (
  <div className="create-flow__form-section  event-details__phone">
    <div className="event-details__phone">
      <Input
        className="event-details__phone"
        label="Phone Number"
        id="phone"
        name="phone"
        data-qa-id="event-phone"
        error={error}
        type="tel"
        maxLength={14}
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder="Drop host contact info here"
        required={false}
      />
    </div>
  </div>
);
